export const useMerchantSlug = () => {
  const hostname = window.location.hostname;

  // Check if it's a custom domain
  const isCustomDomain =
    !hostname.includes("redbirdtab.com") &&
    hostname !== "localhost" &&
    hostname !== "192.168.1.144" &&
    !hostname.endsWith(".vercel.app");

  let merchantSlug = "";

  if (isCustomDomain) {
    // For custom domains, use /orders
    merchantSlug = "/orders";
  } else {
    // For redbirdtab.com subdomains, localhost, or 192.168.1.144
    const pathSegments = window.location.pathname.split("/").filter(Boolean);

    // Ensure there's a merchant slug after the domain
    if (pathSegments.length > 0) {
      merchantSlug = `/${pathSegments[0]}`;
    } else {
      merchantSlug = ""; // Fallback if no merchant slug is present in the URL
    }
  }

  return merchantSlug;
};
